import { action } from 'typesafe-actions';

export const SET_SHOW_LOADING_OVERLAY = 'loadingOverlay/SET_SHOW_LOADING_OVERLAY';
export const setShowLoadingOverlay = (show: boolean) => action(SET_SHOW_LOADING_OVERLAY, show);
